import { render, staticRenderFns } from "./ReportContentSection.vue?vue&type=template&id=53c418ac&scoped=true&"
import script from "./ReportContentSection.vue?vue&type=script&lang=js&"
export * from "./ReportContentSection.vue?vue&type=script&lang=js&"
import style0 from "./ReportContentSection.vue?vue&type=style&index=0&id=53c418ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c418ac",
  null
  
)

export default component.exports
import {QExpansionItem,QItem,QField} from 'quasar'
component.options.components = Object.assign({QExpansionItem,QItem,QField}, component.options.components || {})
